var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYouxiang5Xian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 8L15 10h-5M11.5 14L10 12h5",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2a1 1 0 00-1 1v10a1 1 0 001 1h6.5a.5.5 0 000-1H2V3.601l5.279 3.52a1.3 1.3 0 001.442 0L14 3.6V6.5a.5.5 0 001 0V3a1 1 0 00-1-1H2zm12 1zm-.901 0H2.9l4.933 3.288a.3.3 0 00.332 0L13.1 3z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_youxiang5_xian.980d8678.svg";
export { SvgTongyongYouxiang5Xian as ReactComponent };